export default "__VITE_ASSET__Bgn8ecMr__"